import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLanguage, getLanguages, translate, getAvailableLanguages, getLanguageKey, sessionStore } from '../../../services';
import { siteSettingsState, siteSettingsDispatcher, combineDispatchers, popupDispatcher, combineStates, priceState, priceDispatcher, identityState, identityDispatcher } from '../../../store';
import { AboutWindow, Checkbox, UserMenuSubcategory } from '../../../components';
import { VariableInput } from '../screens/model';
import { PropTypes } from 'prop-types';
import { PricingModule } from '../../../util';
import { LanguageSelector } from './LanguageSelector';
import { Box } from '@mui/material';
import { GlobalIconNew } from '../../../../style/images';

const Setting = ( { changeProp, name, value } ) => {
  const onChange = () => changeProp( name, value );
  return <Checkbox titleFirst title={ translate( name ) } checked={ value } onChange={ onChange }/>; 
};

export class UserMenuComponent extends Component {
  changeLanguage = selection => {
    const language = selection.value;
    setLanguage( language, true );
    location.reload();
  }

  changeCountry = selection => {
    const oldCustomeCode = sessionStorage.getItem("customercode");
    sessionStore.set("oldCustomeCode", oldCustomeCode);
    const customerCode = selection.facValue;
    const data = this.props.user;
    data.properties.CustomerCode = customerCode;
    this.props.updateUser(data);
  }

  changeProp = ( propertyName, propertyValue ) => {
    const { siteSettings } = this.props;
    this.props.changeSiteSettings( { ...siteSettings, properties: { ...siteSettings.properties, [propertyName]: !propertyValue } } );
  }

  changePriceType = () => {
    const { changePriceType, prices } = this.props;
    changePriceType( prices.type === 'listPrice' ? 'netPrice' : 'listPrice' );
  }

  openAboutWindow = () => {
    this.props.setPopup( { title: 'About e-Configure', component: <AboutWindow />, showHeader: false, keepOpen: false } );
  }

  render() {
    const { prices, siteSettings, user } = this.props;
    const { properties } = siteSettings;
    if ( !properties ) {
      return null;
    }
    const availableLanguages = getAvailableLanguages()
    let currentLanguage;
    let languages = [];
    let factories = [];
    let currentFactory;
    let disableFactory = true;

    for ( let lang in siteSettings.availableLanguages ) {
      const value = getLanguageKey( lang );
      if( !availableLanguages.includes( value ) ) {
        continue;
      }
      
      currentLanguage = value === getLanguages().first() ? siteSettings.availableLanguages[lang] : currentLanguage;
      languages.push( { name: siteSettings.availableLanguages[lang], value } );
    }

    if(user.factoryList != null){
      disableFactory = false;
      for(var i = 0; i < user.factoryList.length; i++){
        const facValue = user.factoryList[i].customerCode;
        if(user.factoryList[i].customerCode == user.properties.CustomerCode){
        currentFactory = user.factoryList[i].factiryName;
        }
        factories.push({name: user.factoryList[i].factiryName,facValue})
      }
    }

    const settings = siteSettings.showTestSettings && Object.keys( properties ).map( ( property, key ) =>
      <Setting key={ key } name={ property } value={ properties[property] } changeProp={ this.changeProp }/> 
    );

    return <div className="user-menu">
      <div className='user-menu-header'>
        <span className='header1'>
          {translate("Application Settings")}
        </span>
        <span className='header2'>
          {translate("You can change the country and language.")}
        </span>
      </div>
      { settings }
      { PricingModule.showPrice( siteSettings.pricingModule ) && siteSettings.showPriceSwitch && <Setting name="Show net prices" value={ prices.type === 'netPrice' } changeProp={ this.changePriceType }/> }
      <UserMenuSubcategory>
        
        <div className='icon'>
        <Box component="img" sx={{width:"16px", height:"16px"}} src={ GlobalIconNew }/>
        </div>
        <VariableInput 
          showAs="dropdown" 
          filter={ false } 
          data={ languages } 
          textField="name" 
          valueField="value" 
          value={ currentLanguage }
          onChange={ this.changeLanguage }
        />
        {/* <LanguageSelector data={ languages } value={ currentLanguage } onChange={ this.changeLanguage} ></LanguageSelector> */}
      </UserMenuSubcategory>
      { user.factoryList && <UserMenuSubcategory>
          <span>Country</span>
        <VariableInput 
          showAs="dropdown" 
          filter={ false } 
          data={ factories } 
          textField="name" 
          valueField="value" 
          value={ currentFactory }
          onChange={ this.changeCountry }
          disabled = {disableFactory}
        />
      </UserMenuSubcategory> }
      { siteSettings.properties.showAboutEconfigure &&  
      <UserMenuSubcategory>
        <span onClick={ this.openAboutWindow }>{ translate( 'About e-Configure' ) }</span>
      </UserMenuSubcategory>
      }
    </div>;
  }
}

UserMenuComponent.propTypes = {
  changePriceType: PropTypes.func.isRequired,
  changeSiteSettings: PropTypes.func.isRequired,
  prices: PropTypes.shape( {
    type: PropTypes.string.isRequired
  } ),
  setPopup: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    pricingModule: PropTypes.number.isRequired,
    properties: PropTypes.shape( {} )
  } )
};

export const UserMenu = connect( 
  combineStates( priceState, siteSettingsState, identityState ), 
  combineDispatchers( popupDispatcher, priceDispatcher, siteSettingsDispatcher, identityDispatcher ) 
)( UserMenuComponent );